import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { PriceCoefficientAPI, UpdatePriceCoefficientsRequest } from './model/PriceCoefficient'

export const apiGetPriceCoefficients = async (priceID: number): Promise<PriceCoefficientAPI[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/PriceCoefficients?priceID=${priceID}`).then(
    response => response.data
  )
}

export const apiUpdatePriceCoefficientsBulk = async (
  request: UpdatePriceCoefficientsRequest
): Promise<PriceCoefficientAPI[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65182'

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/PriceCoefficients/UpdatePriceCoefficients`,
    request
  ).then(response => response.data)
}
